<template>
    <v-card @click="registerClick">
        <div class="d-flex flex-no-wrap justify-space-between">
            <div>
                <v-card-title class="text-h5" style="word-break: break-word">
                    {{ advertisement.name }}
                </v-card-title>
                <v-card-subtitle>
                    {{ advertisement.description }}
                    <div class="mt-4">
                        <v-chip class="mt-0" color="blue lighten-3" small> Sponsor </v-chip>
                    </div>
                </v-card-subtitle>
            </div>
            <v-avatar v-if="advertisement.media" class="ma-3" size="125" tile>
                <v-img :src="advertisement.media" contain />
            </v-avatar>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'AdvertisementCard',

    props: {
        advertisement: {
            type: Object,
            required: true,
        },
    },

    methods: {
        registerClick() {
            const alreadyClicked = JSON.parse(localStorage.getItem('already-clicked')) || {};

            const timeClicked = alreadyClicked[this.advertisement.id];

            const recordClick = () => {
                axios.post('/click', { advertisement_id: this.advertisement.id });
                alreadyClicked[this.advertisement.id] = this.$moment().toDate();

                localStorage.setItem('already-clicked', JSON.stringify(alreadyClicked));
            };

            if (timeClicked) {
                if (this.$moment(timeClicked).isBefore(this.$moment().subtract(1, 'day'))) {
                    recordClick();
                }
            } else {
                recordClick();
            }

            window.open(this.advertisement.destination, '_blank');
        },
    },
};
</script>
